import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const MoneyTick = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27 6H5C3.35 6 2 7.35 2 9V23C2 24.65 3.35 26 5 26H27C28.65 26 30 24.65 30 23V9C30 7.35 28.65 6 27 6ZM28 9V11.9C26.05 11.5 24.5 9.962 24.1 8H27C27.55 8 28 8.45 28 9ZM5 8H7.9C7.5 9.963 5.962 11.5 4 11.9V9C4 8.45 4.45 8 5 8ZM4 23V20.1C5.963 20.5 7.5 22.038 7.9 24H5C4.45 24 4 23.55 4 23ZM9.925 24C9.487 20.937 7.063 18.512 4 18.075V13.938C7.063 13.5 9.487 11.075 9.925 8.013H22.062C22.5 11.076 24.925 13.501 27.987 13.938V18.075C24.924 18.513 22.499 20.938 22.062 24H9.925ZM27 24H24.1C24.5 22.05 26.038 20.5 28 20.1V23C28 23.55 27.55 24 27 24Z" />
		<path d="M19.837 13.55C19.937 13.388 20 13.2 20 13C20 12.45 19.55 12 19 12C18.65 12 18.35 12.175 18.163 12.45L14.838 17.438L13.701 16.301C13.526 16.126 13.276 16.013 12.988 16.013C12.438 16.013 11.988 16.463 11.988 17.013C11.988 17.288 12.101 17.538 12.275 17.725L14.275 19.725C14.45 19.9 14.7 20.013 14.988 20.013C15.338 20.013 15.638 19.838 15.826 19.563C15.838 19.551 19.838 13.551 19.838 13.551L19.837 13.55Z" />
	</svg>
);

export default MoneyTick;
